export const floorToDecimal = (num: number, decimal = 0): number => {
  const multiplier = Math.pow(10, decimal)
  return Math.floor(num * multiplier) / multiplier
}
